export enum ProductEnum {
  Milliplex = 'milliplex',
}

export enum ActiveLinkType {
  SelectKits = 'selectKits',
  ReviewAndOrder = 'reviewAndOrder',
  PDPLink = '/product/MM/',
}

export const NextStepLink = {
  undefined: ActiveLinkType.SelectKits,
  '': ActiveLinkType.SelectKits,
  selectKits: ActiveLinkType.ReviewAndOrder,
}

export const PreviousStepLink = {
  reviewAndOrder: ActiveLinkType.SelectKits,
  selectKits: '',
}
export enum SampleTypeYesNoOptions {
  Yes = 'Yes',
  No = 'No',
}

export enum AssayType {
  Premixed = 'Premixed',
  Configurable = 'Configurable',
}

export const MilliplexKitTypes = {
  'Predesigned Panel': 'Configurable',
  'Premixed Kit': 'Premixed',
}

export const MilliplexInstrumentTypeList = [
  'FLEXMAP 3D®',
  'Luminex 200™',
  'MAGPIX®',
  'xMAP® INTELLIFLEX®',
  'xMAP® INTELLIFLEX® DR-SE',
]

export enum AssayTypeOptions {
  Qualified = 'Qualified',
  Screening = 'Screening',
  BothQualifiedAndScreening = "'Both Qualified and Screening'",
}
